var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"reviews-count",class:_vm.positionClass},[(_vm.count === 0)?_c('span',[_vm._v(_vm._s(_vm.$t('emptyState.notReviewedYet')))]):_c('span',[_vm._v("Overall Rating based on "),_c('strong',[_vm._v(_vm._s(_vm.count)+" Student reviews")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }